import { createSlice } from '@reduxjs/toolkit'

export const ProjectInfoConfigurationSlice = createSlice({
    name: 'project_info_configuration_slice',
  initialState: {
    value: {
      updateGlossaryPermission:false
    },
  },
  reducers: {
    updateProjectInfoConfiguration: (state, action) => {
      if(action.payload.type){
          return { ...state,
              value:{
                ...state.value,[action.payload.type]: action.payload.value
              }              
          }
      }
      else{
        state.value = action.payload
      }
    },
  }
})

export const { updateProjectInfoConfiguration} = ProjectInfoConfigurationSlice.actions

export default ProjectInfoConfigurationSlice.reducer